import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomInput from "../TextField/TextFeild";
import { ModifyAlias } from '../../store/slices/invitesSlice';
import { toast } from 'react-toastify';

const ModifyInvitePopup = ({ show, onClose, row }) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    alias: Yup.string().required("Alias is required").min(4, "Alias must be atleast 4 characters"),
    priority: Yup.string().required("Priority is required"),
    hidden: Yup.boolean()
  });

  const formik = useFormik({
    initialValues: {
      alias: '',
      priority: '',
      hidden: false
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const { priority, hidden, alias } = values;
        
        const payloadData = {
          id: row.attributes.id,
          type: 'user',
          attributes: {
            priority, 
            hidden
          },
        };

        // Add alias only if it doesn't already exist
        if (!row?.attributes?.metadata?.["3"]?.alias) {
          payloadData.attributes.alias = alias;
        }

        await dispatch(
          ModifyAlias({
            message: 'Status Updated.',
            payload: payloadData,
          })
        ).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        toast.error(error, {
          position: "top-right",
          autoClose: 3000,
        });

        console.error('Update failed:', error);
        // You could add error state here to show in UI
      } finally {
        setSubmitting(false);
      }
    }
  });

  useEffect(() => {
    if (row && show) {
      const metaData = row.attributes?.metadata?.["3"];
      formik.setValues({
        alias: metaData?.alias || '',
        priority: metaData?.priority || '',
        hidden: metaData?.hidden || false
      });
    }
  }, [row, show]);

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>{row?.attributes?.metadata?.["3"]?.alias ? 'Modify Invitation' : 'Publish'}</Modal.Title>
      </Modal.Header>
      <form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <div className="form-card shadow-none mb-0">
            <div className="">
              <CustomInput
                label="Alias"
                id="alias"
                name="alias"
                value={formik.values.alias}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.alias && formik.errors.alias}
                disabled={!!row?.attributes?.metadata?.["3"]?.alias}
                required
              />

              <CustomInput
                label="Priority"
                id="priority"
                name="priority"
                value={formik.values.priority}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.priority && formik.errors.priority}
                required
              />

              <div className="form-check mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="hidden"
                  name="hidden"
                  checked={formik.values.hidden}
                  onChange={formik.handleChange}
                />
                <label className="form-check-label" htmlFor="hidden">
                  Hidden
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-danger"
            onClick={onClose}
            disabled={formik.isSubmitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-secondary"
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {formik.isSubmitting ? "Updating..." : "Update"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ModifyInvitePopup;